{
  "version": 1,
  "asset_id": "fee74460-33e7-4916-a365-7036b04af51f",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/fee74460-33e7-4916-a365-7036b04af51f/blog-upload-480.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/fee74460-33e7-4916-a365-7036b04af51f/blog-upload-480.avif",
  "original_filename": "blog-upload-480.avif",
  "size": 4408,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:02:28Z"
}
